<div id="time-context" class="upper__container mb-5 mb-sm-2" role="status" aria-atomic="true">
    <p
        class="visually-hidden"
        [innerHTML]="'dynamische_frontend_texte.datum_auswahl.html_content.position_info' | translate | safeStyle"
    ></p>
    @if (dateFirst) {
        <p
            [innerHTML]="
                'dynamische_frontend_texte.datum_auswahl.html_content.auswahl'
                    | translate
                    | replaceDateTime: selectedDate
                    | async
            "
            class="mb-0"
        ></p>
    }
    <p
        [innerHTML]="'dynamische_frontend_texte.datum_auswahl.html_content.label_zeit_auswahl' | translate | safeStyle"
    ></p>
</div>
@if (!timePickSecondLoading) {
    <div>
        @for (court of availableAgencies; track court.name; let firstCourt = $first) {
            <div class="row">
                @for (singleTime of court.times; track singleTime.time; let first = $first) {
                    <div class="col-sm-4 col-6 pr-sm-1">
                        <div class="time--wrapper">
                            <a
                                #slot
                                tabindex="0"
                                role="button"
                                [attr.id]="firstCourt && first ? 'first' : null"
                                [attr.aria-labelledby]="firstCourt && first ? 'time-context first' : null"
                                [attr.aria-pressed]="singleTime === selectedTime"
                                [attr.title]="
                                    'dynamische_frontend_texte.datum_auswahl.attribute_text.zeit_auswahl_eintrag_title'
                                        | translate
                                        | replaceDateTime: singleTime.time
                                        | async
                                "
                                (click)="timeClick(singleTime, $event)"
                                (keydown.enter)="timeClick(singleTime, $event)"
                                (keydown.space)="timeClick(singleTime, $event)"
                                [innerHTML]="
                                    'dynamische_frontend_texte.datum_auswahl.html_content.zeit_auswahl_eintrag'
                                        | translate
                                        | replaceDateTime: singleTime.time
                                        | async
                                "
                            ></a>
                        </div>
                    </div>
                }
            </div>
        }
        @if (dateFirst) {
            <div class="mt-4" role="status" aria-atomic="true">
                @if (timeSelected) {
                    <p class="selected-date mb-0">
                        <span
                            [innerHTML]="
                                'dynamische_frontend_texte.zeit_auswahl.html_content.wunschtermin'
                                    | translate
                                    | safeStyle
                            "
                        ></span>
                        <span class="fw-bold"> {{ selectedValuesText }}</span>
                    </p>
                }
            </div>
        }
    </div>
}

@if (timePickSecondLoading) {
    <div class="row">
        <div class="col-6">
            <otb-loading-animation-dots
                [text]="'dynamische_frontend_texte.lade_animation.zeiten'"
            ></otb-loading-animation-dots>
        </div>
    </div>
}
